<button (click)="isVisible = !isVisible" type="button" mat-icon-button>
  <mat-icon [svgIcon]="isVisible ? 'eye' : 'eye-slash'"></mat-icon>
</button>
